import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05447a73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-block" }
const _hoisted_2 = {
  id: "content-download-railway-station",
  class: "jr-overflow-hidden jr-absolute jr-w-full jr-top-28 jr-z-10 jr-bg-white"
}
const _hoisted_3 = { class: "jr-py-5 jr-ml-6" }
const _hoisted_4 = { class: "jr-flex jr-items-center" }
const _hoisted_5 = { class: "jr-mr-8 jr-text-base jr-font-medium jr-text-primary" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jr-text-s" }, "路線利用者の居住地・勤務地分布", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "居住地", -1))
const _hoisted_8 = { class: "jr-absolute jr-h-0.5 jr-w-full jr-bottom-0 jr-left-0 jr-bg-blue-light" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "勤務地", -1))
const _hoisted_10 = { class: "jr-absolute jr-h-0.5 jr-w-full jr-bottom-0 jr-left-0 jr-bg-blue-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterNavigation = _resolveComponent("FilterNavigation")!
  const _component_RailwayStationSelector = _resolveComponent("RailwayStationSelector")!
  const _component_StationBarchart = _resolveComponent("StationBarchart")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FilterNavigation),
    _createVNode(_component_RailwayStationSelector, { onMinimum: _ctx.handleMinimum }, null, 8, ["onMinimum"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.selectedRailwayLine), 1),
          _hoisted_6
        ])
      ], 512), [
        [_vShow, _ctx.isCapturing]
      ]),
      _createElementVNode("div", {
        class: "transition jr-flex jr-w-full jr-mt-6.5 jr-border-b jr-border-gray-medium",
        style: _normalizeStyle({ paddingLeft: _ctx.isCapturing ? '25px' : _ctx.minimum ? '90px'  : '265px' })
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["jr-relative jr-w-station-tab jr-cursor-pointer jr-text-sm jr-font-medium jr-text-gray jr-text-center jr-pb-1", { 'jr-font-bold jr-text-blue-light': _ctx.selectedTab === _ctx.RailwayStationTab.Resident }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTabChange(_ctx.RailwayStationTab.Resident)))
        }, [
          _hoisted_7,
          _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
            [_vShow, _ctx.selectedTab === _ctx.RailwayStationTab.Resident]
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["jr-relative jr-w-station-tab jr-cursor-pointer jr-text-sm jr-font-medium jr-text-gray jr-text-center jr-pb-1", { 'jr-font-bold jr-text-blue-light': _ctx.selectedTab === _ctx.RailwayStationTab.Work }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTabChange(_ctx.RailwayStationTab.Work)))
        }, [
          _hoisted_9,
          _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
            [_vShow, _ctx.selectedTab === _ctx.RailwayStationTab.Work]
          ])
        ], 2)
      ], 4),
      _createVNode(_component_StationBarchart, {
        class: "transition",
        style: _normalizeStyle({ left: _ctx.isCapturing ? '30px' : _ctx.minimum ? '254px' : '372px' })
      }, null, 8, ["style"])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}